import { combineReducers } from 'redux';
import breakpoints from 'store/Reducers/breakpoints/reducer';
import dashboard from 'store/Dashboard/reducer';
import locale from 'store/locale/reducer';
import host from 'store/Host/reducer';
import manage from 'store/Manage/reducer';
import preferences from 'store/Preferences/reducer';
import hostDetail from 'store/HostDetail/reducer';
import hostEditCreate from 'store/HostEditCreate/reducer';
import fileUploaderContext from 'store/FileUploaderContext/reducer';
import knowledgeBase from 'store/KnowledgeBase';
import knowledgeBaseEditCreate from 'store/KnowledgeBaseEditCreate';
import settings from 'store/Settings/reducer';
import customAttributes from 'store/CustomAttributes/reducer';
import agents from 'store/Agents/reducer';
import schedule from 'store/Schedule/reducer';
import errors from 'store/errors/reducer';
import faraday from 'store/Faraday/Faraday';
import filters from 'store/Filters/reducer';
import modals from 'store/modals/reducer';
import config from 'store/Config/reducer';
import license from 'store/License/reducer';
import sideBar from 'store/SideBar/reducer';
import global from 'store/Global/reducer';
import { connectRouter } from 'connected-react-router';
import pipelines from 'store/Pipelines/reducer';
import jobs from 'store/Jobs/reducer';
import sesion from '../Sesion/Sesion';
import manageEditCreate from './ManageEditCreate';
import workspace from './Workspace';
import workspaceEditCreate from './WorkspaceEditCreate';
import tags from './Tags';
import services from 'store/Services/reducer';
import assetDetail from 'store/Contextualization/AssetDetail/reducer';
import hostsGeneral from 'store/HostsGeneral/reducer';
import servicesGeneral from 'store/ServicesGeneral/reducer';
import manageGeneral from 'store/ManageGeneral/reducer';
import credentials from 'store/Credentials/reducer';
import groupVulns from 'store/GroupVulns/reducer';
import whatsNew from 'store/WhatsNew/reducer';

// Core reducer slices, kept as a plain object (not wrapped in combineReducers) so
// src/ee/store/Reducers/index.js can spread these plus the Enterprise Edition-only
// slices (license, analytics, tasks, projects, users, notifications, roles,
// executiveReport, executiveReportEditCreate, legacyExecutiveReport,
// legacyExecutiveReportEditCreate) without duplicating every import above.
export const coreReducers = {
  sesion,
  faraday,
  knowledgeBase,
  customAttributes,
  filters,
  manage,
  manageEditCreate,
  host,
  hostDetail,
  hostEditCreate,
  knowledgeBaseEditCreate,
  workspace,
  workspaceEditCreate,
  tags,
  settings,
  dashboard,
  breakpoints,
  locale,
  preferences,
  fileUploaderContext,
  agents,
  schedule,
  errors,
  modals,
  config,
  license,
  sideBar,
  pipelines,
  jobs,
  global,
  services,
  assetDetail,
  hostsGeneral,
  servicesGeneral,
  manageGeneral,
  credentials,
  groupVulns,
  whatsNew
};

const createRootReducer = (history) => combineReducers({
  router: connectRouter(history),
  ...coreReducers
});
export default createRootReducer;
